export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/2WitNotaryRec-71a2e6a32c152d9125f14aab9e4c9b8c.PNG";